import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        form: null,
        businessForm: null
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/login/registerFormViewModel.js
 **/